import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getPdfReport } from '../../functions/api'

type Props = {
  patientCode: string
  patientId: string
}

const PdfReportLink = ({ patientCode, patientId }: Props) => {
  const [url, setUrl] = useState<string | null>(null)
  const { t } = useTranslation()

  // Effect to fetch and update URL.
  useEffect(() => {
    const fetchPdfReport = async () => {
      const response = await getPdfReport(patientId)

      if (response.status === 200 && response.data) {
        const blob = new Blob([response.data], { type: 'application/pdf' })
        setUrl(URL.createObjectURL(blob))
      }
    }

    fetchPdfReport()
  }, [patientId])

  // Cleanup effect when url changes or component unmounts
  useEffect(() => {
    return () => {
      if (url) URL.revokeObjectURL(url)
    }
  }, [url])

  const downloadFile = () => {
    if (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = `map-adtest-${patientCode}.pdf`
      a.click()
    }
  }

  if (!url) return <></>

  return <button onClick={downloadFile}>{t('button.donwload_report')}</button>
}

export default PdfReportLink
